import {select, take} from 'redux-saga/effects';
import * as authActionTypes from '../../auth/authActionTypes';

const provideTokenToServicesFlow = function* provideTokenToServicesFlow() {
    const {serviceManager} = yield select(state => state.application);

    while (true) {
        const {payload} = yield take(authActionTypes.AUTH_SESSION_STARTED);
        try {
            const miaService = serviceManager.loadService('miaService');
            miaService.setAccessToken(payload.token);
        } catch (e) {
            // no-op
        }
        try {
            const miaFileAssetsService = serviceManager.loadService('miaFileAssetsService');
            miaFileAssetsService.setAccessToken(payload.token);
        } catch (e) {
            // no-op
        }
    }
};

export default provideTokenToServicesFlow;
